(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iamfit-fit-friday-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iamfit-friday-header')) {
    customElements.define('iamfit-friday-header', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.links = Array.from(this.querySelectorAll('[data-iff-category]'));
        this.refresh = () => {
          cancelAnimationFrame(this.linkFrame);
          this.linkFrame = requestAnimationFrame(() => this.updateLinks());
        };
        document.addEventListener('submit', this.refresh);
        document.addEventListener('change', this.refresh);
        window.addEventListener('popstate', this.refresh);
        const status = document.querySelector('fit-friday-catalog [data-ff-status]');
        if (status) {
          this.observer = new MutationObserver(this.refresh);
          this.observer.observe(status, { childList: true, characterData: true, subtree: true });
        }
        this.updateLinks();
        this.end = Date.parse(this.dataset.end);
        this.clock = this.querySelector('[data-iff-clock]');
        this.fields = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector(`[data-iff-${key}]`));
        this.onVisibility = () => {
          clearInterval(this.interval);
          if (!document.hidden && this.tick()) this.interval = setInterval(() => this.tick(), 1000);
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onVisibility();
      }
      updateLinks() {
        const current = new URL(location.href);
        const category = current.searchParams.get('ff_category') || '';
        const products = document.querySelector('fit-friday-copy .ffcp-products');
        this.links.forEach(link => {
          const target = new URL(current);
          target.searchParams.delete('page');
          target.searchParams.delete('ff_page');
          if (link.dataset.iffCategory) target.searchParams.set('ff_category', link.dataset.iffCategory);
          else target.searchParams.delete('ff_category');
          target.hash = products ? products.id : '';
          link.href = target.toString();
          if (category === link.dataset.iffCategory) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
      }
      tick() {
        if (!Number.isFinite(this.end)) return false;
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        if (remaining === 0) {
          this.querySelector('[data-iff-label]').textContent = this.dataset.ended;
          this.querySelector('[data-iff-button]').textContent = this.dataset.endedButton;
          this.clock.hidden = true;
          clearInterval(this.interval);
          return false;
        }
        const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        values.forEach((value, index) => {
          const next = String(value).padStart(2, '0');
          if (this.fields[index].textContent !== next) this.fields[index].textContent = next;
        });
        return true;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.linkFrame);
        clearInterval(this.interval);
        this.observer?.disconnect();
        document.removeEventListener('submit', this.refresh);
        document.removeEventListener('change', this.refresh);
        window.removeEventListener('popstate', this.refresh);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
